import Row from "@meridian/components/row";
import Loader from "@meridian/components/loader";
import Column from "@meridian/components/column";
import React from "react";

export default function AppLoader(props) {
    return <Column className="appLoader" heights="fill" alignmentHorizontal="center">
        <Row widths="fill">
            <Loader type="circular"/>
        </Row>
    </Column>;
}


// WEBPACK FOOTER //
// ./src/components/app-loader.js